<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="600px">
            <v-toolbar color="secondary">
              <v-toolbar-title class="white--text text-overline">Personal Information</v-toolbar-title>
              <v-spacer></v-spacer>
                <EditPersonal />
            </v-toolbar>
            <!-- Trials -->
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Name:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1 text-button">{{ patient.firstname}} {{ patient.surname }}</v-col>
                  <v-col cols="2" md="1"></v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Known As:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1 text-button">{{ patient.known_as}}</v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="known_as_pr">
                        <v-icon v-if="privacy.known_as_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Gender:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    <span class="description" v-if="patient.gender == 'm'">Male</span>
                    <span class="description" v-if="patient.gender == 'f'">Female</span>
                    <span class="description" v-else></span>
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="gender_pr">
                        <v-icon v-if="privacy.gender_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">NHS Number:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ patient.nhs_number}}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="nhs_number_pr">
                        <v-icon v-if="privacy.nhs_number_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Phone (Home):</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ patient.phone_home }}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="phone_home_pr">
                        <v-icon v-if="privacy.phone_home_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Phone (Mobile):</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ patient.phone_mobile }}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="phone_mobile_pr">
                        <v-icon v-if="privacy.phone_mobile_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Address:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ address.street }}, {{ address.post_code }}, {{ address.city }}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="address_pr">
                        <v-icon v-if="privacy.address_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Blood Group:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ patient.blood_group }}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="blood_group_pr">
                        <v-icon v-if="privacy.blood_group_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Language:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    <span
                        class="description"
                        v-if="patient.language"
                      >{{ patient.language.language }}</span>
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="language_pr">
                        <v-icon v-if="privacy.language_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Religion:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    <span
                        class="description"
                        v-if="patient.religion"
                      >{{ patient.religion.religion }}</span>
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="religion_pr">
                        <v-icon v-if="privacy.religion_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Organ Donor:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    <span class="description" v-if="patient.organ_donor">Yes</span>
                      <span class="description" v-else>No</span>
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="organ_donor_pr">
                        <v-icon v-if="privacy.organ_donor_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row> 
                  <v-col cols="12" md="3" class="pl-5 pb-1">DNR:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    <span class="description" v-if="patient.dnr">Yes</span>
                      <span class="description" v-else>No</span>
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="organ_donor_pr">
                        <v-icon v-if="privacy.organ_donor_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Covid Status:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ patient.covid_status }}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="covid_status_pr">
                        <v-icon v-if="privacy.covid_status_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ma-1">
                <v-row>
                  <v-col cols="12" md="3" class="pl-5 pb-1">Notes:</v-col>
                  <v-col cols="10" md="8" class="pl-5 pb-1">
                    {{ patient.notes }}
                  </v-col>
                  <v-col cols="2" md="1">
                    <div @click="visibility" id="notes_pr">
                        <v-icon v-if="privacy.notes_pr">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </div>
                  </v-col>
                </v-row>
              </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import EditPersonal from "@/components/dialogs/EditPersonal";
import { mapGetters } from "vuex";
export default {
  name: "Personal",
  components: {
    EditPersonal
  },

  data: () => ({
    dialog: false,
    valid: true,
    title: "Personal Information",
    btnTitle: "Edit",
    privacyChange: {
      key: '',
      status: ''
    },
    profile: {
      firstname: "",
      surname: "",
      date_of_birth: ""
    },
    person: {
      language_id: "",
      gender: "",
      religion_id: "",
      phone_mobile: "",
      phone_home: "",
      known_as: "",
      nhs_number: "",
      date_of_birth: "",
      blood_group: "",
      organ_donor: "",
      covid_status: "",
      notes: "",
      surname: "",
      firstname: "",
      dnr:""
    },
    select: {
      gender: "",
      religion: "",
      language: ""
    },
    privacy: {
      religion_pr: "",
      language_pr: "",
      surname_pr: "",
      firstname_pr: "",
      phone_mobile_pr: "",
      phone_home_pr: "",
      known_as_pr: "",
      nhs_number_pr: "",
      date_of_birth_pr: "",
      blood_group_pr: "",
      organ_donor_pr: "",
      dnr_pr: '',
      notes_pr: ""
    },
    address: {
      street: "",
      post_code: "",
      city: "",
      visibility: ""
    },
    gender: [
      { id: "m", name: "male" },
      { id: "f", name: "female" }
    ],
    covid: [{ value: "Unknown" }, { value: "Immune" }, { value: "Not Immune" }],
    bloodGroups: [
      { id: "A+", group: "A+" },
      { id: "A-", group: "A-" },
      { id: "AB+", group: "AB+" },
      { id: "AB-", group: "AB-" },
      { id: "B+", group: "B+" },
      { id: "B-", group: "B-" },
      { id: "O+", group: "O+" },
      { id: "O-", group: "O-" }
    ],
    organDonor: [
      { text: "Yes", value: 1 },
      { text: "No", value: 0 }
    ],
    dnr: [
      { text: "Yes", value: 1 },
      { text: "No", value: 0 }
    ]
  }),
  methods: {
    visibility(el) {
      var val = el.currentTarget.id;
      for (const item of Object.entries(this.privacy)) {
        if (val == item[0]) {
          this.privacyChange.key = val;
          this.privacyChange.status = !item[1];
          this.$store.dispatch("personal/aUpdatePrivacy", this.privacyChange)
          .then(response => {
            if (response) {
              this.privacy = Object.assign({}, this.thePrivacy);
            }
          })
          break;
        }
      }
    },
    deleteItem(item) {
      this.$store.dispatch("user/aDeleteProfile", item.id);
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        delete this.person.language;
        delete this.person.religion;
        const updates = {
          patient: this.person,
          residence: this.address
        };
        this.$store.dispatch("personal/aUpdatePerson", updates).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters("personal", {
      patient: "gPatient",
      me: "gMe",
      addressed: "gAddress",
      editName: "gEditName",
      uLanguages: "gLanguages",
      uReligion: "gReligion",
      thePrivacy: "gPrivacy"
    })
  },
  created() {
    this.$store.dispatch("personal/aPersonalDetails").then(response => {
      if (response) {
        this.person = Object.assign({}, this.patient);
        this.address = Object.assign({}, this.addressed);
        this.privacy = Object.assign(this.privacy, this.thePrivacy);
      }
    });
  }
};
</script>
